import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { devConsolelog } from "../Utility";

const withCabPackage = (WrappedComponent) => {
  return (props) => {
    const { cabPkgId } = useParams();
    const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const fetchPackage = async () => {
        if (!cabPkgId) {
          setLoading(false);
          return;
        }
        try {
          const docRef = doc(db, "transportPackages", cabPkgId);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            devConsolelog("cab pkg data-", docSnap.data());
            setFormData(docSnap.data());
          } else {
            console.error("No such package found for ID:", cabPkgId);
          }
        } catch (error) {
          console.error("Error fetching cab package:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchPackage();
    }, [cabPkgId]);

    if (loading) {
      return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
          <CircularProgress />
        </Box>
      );
    }

    return <WrappedComponent {...props} formData={formData} />;
  };
};

export default withCabPackage;
